import * as stylex from "@stylexjs/stylex";
import { spacing } from "@softmax/design-system/tokens.stylex";
import type { MouseEventHandler, ReactElement, ReactNode } from "react";
import type { SiteNavigationLinkProps } from "./site-navigation-types";

export function SiteIdentity({
  homeHref,
  brand,
  switcher,
  renderLink,
  onNavigate,
}: {
  readonly homeHref: string;
  readonly brand: { readonly markSrc: string; readonly wordmarkSrc: string };
  readonly switcher: ReactNode;
  readonly renderLink: (props: SiteNavigationLinkProps) => ReactElement;
  readonly onNavigate: MouseEventHandler<HTMLAnchorElement>;
}) {
  return (
    <div {...stylex.props(styles.start)}>
      {renderLink({
        href: homeHref,
        onClick: onNavigate,
        "aria-label": "Softmax home",
        ...stylex.props(styles.logo),
        children: (
          <>
            <img
              src={brand.markSrc}
              alt=""
              {...stylex.props(styles.brandmark)}
            />
            <img
              src={brand.wordmarkSrc}
              alt="softmax"
              width={96}
              height={19}
              {...stylex.props(styles.wordmark)}
            />
          </>
        ),
      })}
      {switcher}
    </div>
  );
}

const styles = stylex.create({
  start: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    gap: {
      default: spacing.space8,
      "@media (min-width: 768px)": spacing.space16,
    },
  },
  logo: {
    position: "relative",
    display: "block",
    width: 116.98,
    height: 19.16,
    flexShrink: 0,
    opacity: { default: 1, ":hover": 0.7, ":active": 0.5 },
    "::after": {
      content: '""',
      position: "absolute",
      insetInline: 0,
      top: "50%",
      minHeight: 44,
      transform: "translateY(-50%)",
    },
  },
  brandmark: {
    position: "absolute",
    top: 2.77,
    left: 0,
    height: 16.78,
    width: 16.44,
  },
  wordmark: {
    position: "absolute",
    top: 0,
    left: 21.17,
    height: 19.16,
    width: 95.82,
    maxWidth: "none",
  },
});
